import { Component, ElementRef, Input } from '@angular/core';
import * as Plotly from 'plotly.js-dist-min'
import { ChartsCommonFunctions } from '../chartsCommonFunctions';
import { environment } from 'src/environments/environment';
import { ActivatedRoute } from '@angular/router';
import { RxAuthService } from 'src/app/services/rx-auth/rx-auth.service';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';
import {NgIf} from '@angular/common';
import { AfterViewInit } from '@angular/core';

@Component({
  selector: 'app-company-profile',
  templateUrl: './company-profile.component.html',
  styleUrls: ['./company-profile.component.scss'],
  standalone: true,
  imports: [
    NgIf
  ]
})
export class CompanyProfileComponent {
  constructor(
    private common:ChartsCommonFunctions,
    private elementRef:ElementRef,
    private route:ActivatedRoute,
    public auth:RxAuthService,
    private http:HttpClient
  ){}

  @Input() rcl: number | null = null;
  @Input() model: any = 'CompanyProfileModel';
  @Input() chartId: string = '';
  isReadyObservable: Subject<boolean> = new Subject<boolean>;
  showchart:boolean = false;

  webTrafficChart: any = null;
  sharePriceChart: any = null;
  totalRevenueChart: any = null;
  grossProfitChart: any = null;
  profileData:any = null;

  webTrafficData:any = [];
  sharePriceData:any = [];
  totalRevenueData:any =[];
  grossProfitData:any =[];

  chartData: any = {
    data: [
      {
        mode:'lines+markers',
        type:'scatter',
        line: {
          color:'#5a5a5a',
          width: 2
        }
      }
    ],
    layout: {
      legend: { orientation: 'h', y: 1.2, bgcolor:'rgba(0,0,0,0)' },
      xaxis: {
        type:'date',
        dtick:'M12',
        tickformat: '%Y',
        showline:false,
        showgrid:false,
        showticklabels:false,
        zeroline:false

        //title: 'X-axis', // x-axis label
      },
      yaxis: {
        showline:false,
        showgrid:false,
        showticklabels:false,
        zeroline:false
        //title: 'Y-axis' // y-axis label
      },

      margin: { r: 0, l: 0, t: 0, b: 0 },
      height:50,
      width:150,
      autosize:true,

    },
    config: {
      displayModeBar:false,
      staticPlot: this.common.isMobile()

    },

  };

  async ngOnInit() {
    //this.isReadyObservable.next(false)
    //await this.getProfileData()

    //this.plotlyChart = this.chartContainer.nativeElement.querySelector('#plot_1')
    //Create web traffic chart


    
  }


  ngAfterViewInit() {
    this.getProfileData()
  }


  async getProfileData(){
    let data:any = null
    /*{
      retailerLogo: "https://drive.google.com/thumbnail?id=1bH-yOjN7t5JDY-5GZynow2dJcvEXDAbI",
      retailerName: "Dior",
      retailerLists: ["Europe Top500 Brands", "Europe Top1000", "UK Top500"],
      retailerHQ: "France",
      corpName: "Christian Dior SE",
      corpTicker: "PA: CDI",
      website: "dior.com",
      twitter: "@dior",
      webTrafficData: {
          x:  [
            "2019",
            "2020",
            "2021",
            "2022",
            "2023"
            ],
          y: [
            23.799709776806363,
            12.75456683664443,
            -10.23249260619756,
            5.43792596116644594,
            -3.359938828969253
            ],
          marker:{
            "color":["green", "",  "red", "", ""],
            "size":[7, 0, 7, 0, 0],
            "opacity":1
          }

        },
      webTrafficMax: "2.5mn",
      webTrafficMin: "2.1mn",
      sharePriceData:  {
          x:  [
            "2019",
            "2020",
            "2021",
            "2022",
            "2023"
            ],
          y: [
            10.799709776806363,
            23.75456683664443,
            5.23249260619756,
            -20.43792596116644594,
            -3.359938828969253
            ],
          marker:{
            "color":["", "green",  "", "red", ""],
            "size":[0, 7, 0, 7, 0],
            "opacity":1
          }

        },
      sharePriceMax: "2.5mn",
      sharePriceMin: "2.1mn",
      totalRevenueData:  {
          x:  [
            "2019",
            "2020",
            "2021",
            "2022",
            "2023"
            ],
          y: [
            23.799709776806363,
            12.75456683664443,
            -10.23249260619756,
            5.43792596116644594,
            -3.359938828969253
            ],
          marker:{
            "color":["green", "",  "red", "", ""],
            "size":[7, 0, 7, 0, 0],
            "opacity":1
          }

        },
      totalRevenueMax: "2.5mn",
      totalRevenueMin: "2.1mn",
      grossProfitData:  {
          x:  [
            "2019",
            "2020",
            "2021",
            "2022",
            "2023"
            ],
          y: [
            23.799709776806363,
            12.75456683664443,
            -10.23249260619756,
            5.43792596116644594,
            -3.359938828969253
            ],
          marker:{
            "color":["green", "green",  "red", "#B05995", "red"],
            "size":[7, 0, 7, 0, 0],
            "opacity":1
          }

        },
        grossProfitMax: "2.5mn",
        grossProfitMin: "2.1mn",
        researched: "Researched 02-09-2015 to 20-01-2024",
        sources: "Sources: RetailX, SimilarWeb (web traffic, European visits included), Yahoo Finance (financial records). Green and red dots represent the highest and lowest recorded data point respectively. ",
        financialsReference: 'Year end 2023',
        copyrightYear: 2024

    }*/
    //Get data asynchronously

      let url = `${environment.backend_base}main/visualizations/get_visualization_data/`;
      let payload = {
        visualization: this.model,
        rcl: this.rcl,
        component: this.route.component!.name
      };

      let options = this.auth.httpOptions;

      await this.http
        .post(url, payload, this.auth.httpOptions)
        .subscribe((response: any) => {
          //this.chartData.data[0].z = response.data[0].fields.json.z;
          this.profileData = response.data[0].fields.json
          this.profileData.retailerLists = this.profileData.retailerLists.map((item:any) => {return ' '+item})

          this.webTrafficData = this.mergeData(this.chartData.data, this.profileData.webTrafficData)
          this.sharePriceData = this.mergeData(this.chartData.data, this.profileData.sharePriceData)
          this.totalRevenueData = this.mergeData(this.chartData.data, this.profileData.totalRevenueData)
          this.grossProfitData = this.mergeData(this.chartData.data, this.profileData.grossProfitData)


          this.showchart = true;
          this.isReadyObservable.next(true)

          //Create web traffic chart
          this.webTrafficChart = this.elementRef.nativeElement.querySelector('#web-traffic-plot')
          if (this.webTrafficChart){
            this.webTrafficChart = Plotly.newPlot(this.webTrafficChart, this.webTrafficData, this.chartData.layout, this.chartData.config)
          }
          //Create share price chart
          
          this.sharePriceChart = this.elementRef.nativeElement.querySelector('#share-price-plot')
          if (this.sharePriceChart) {
            this.sharePriceChart = Plotly.newPlot(this.sharePriceChart, this.sharePriceData, this.chartData.layout, this.chartData.config)
          }
          //Create revenue chart
          
          this.totalRevenueChart = this.elementRef.nativeElement.querySelector('#total-revenue-plot')
          if (this.totalRevenueChart) {
            this.totalRevenueChart = Plotly.newPlot(this.totalRevenueChart, this.totalRevenueData, this.chartData.layout, this.chartData.config)
          }
          //Create profit chart
          this.grossProfitChart = this.elementRef.nativeElement.querySelector('#gross-profit-plot')
          if (this.grossProfitChart) {
            this.grossProfitChart = Plotly.newPlot(this.grossProfitChart, this.grossProfitData, this.chartData.layout, this.chartData.config)
          }
          
          

        });



  }

  mergeData(dataTemplate:any, data:any) {
    return [{...data, ...dataTemplate[0]}]
  }
}


